const cancel = 'Avbryt'
const save = 'Spara'

export default {

  global: {
    generalError: 'Hoppsan! Begäran kunde tyvärr inte hanteras. Var vänlig och ladda sidan igen.',
    signature: 'Med vänlig hälsning,',
  },

  component: {
    actionBar: {
      actions: 'Åtgärder',
      hideActions: 'Dölj åtgärder',
      next: 'Nästa',
      previous: 'Föregående',
    },

    addButton: {
      add: 'Lägg till',
    },

    aiSummaryBox: {
      transcript: 'Transkript',
      summary: 'Sammanfattning',
    },

    attachments: {
      add: 'Lägg till CV eller andra bilagor',
      placeholderWithDescription: 'Lägg till de begärda bilagorna',
      remove: 'Ta bort',
      allowedFileTypes: 'Tillåtna filtyper',
      errors: {
        size: 'Filen är för stor, max.storlek för filen är 5MB.',
        empty: 'Filen saknar data',
        invalidType: fileType => `Beklagar, av säkerhetsskäl är ${fileType}-filer inte tillåtna`,
        typeNotWhitelisted: 'Tyvärr är filtypen inte tillåten.',
      },
    },

    agreeTos: {
      privacyLinkText: 'integritetspolicy',
      termsLinkText: 'Villkor',
      privacyPolicyText: 'Vi värdesätter din integritet, läs vår ',
      termsText1: 'Läs och godkänn ',
      termsText2: 'innan du ger oss dina personuppgifter.',
      privacyLink: 'https://get.recright.com/sv/integritetspolicy/',
      termsLink: 'https://get.recright.com/sv/recright-anvandaravtal-arbetssokande',
      privacyInfo: mail => `Om du inte vill att vi hanterar dina personuppgifter så kan du begära att vi avlägsnar dem genom att skicka ett meddelande till ${mail}.`,
      customSupportPrivacyInfo: link => `Om du inte vill att vi ska behandla dina personuppgifter kan du be om borttagning genom att kontakta ${link}.`,
    },

    buttons: {
      close: 'Stäng',
    },

    competencies: {
      addCompetency: 'Lägg till ny kompetens',
      edit: 'Redigera kompetens',
      done: 'Klar',
      defaultsDescription: 'Vi har definierat några bra standarkompetenser till att börja med, ifall du är osäker på vilka kompetenser du skall använda.',
      getDefaults: 'Hämta standardkompetenser',
    },

    competency: {
      warning: 'Radera kompetens och värderingar?',
    },

    confirmDelete: {
      delete: 'Radera',
      cancel: 'Annulera',
      confirm: 'Bekräfta',
    },

    confirm: {
      cancel: 'Ta bort tagningen',
      confirm: 'Försök igen',
    },

    confirmButton: {
      wait: count => `Vänta ${count}`,
      confirm: 'Bekräfta',
    },

    controlStatus: {
      text: {
        empty: 'Fyll i',
        valid: () => 'Klart',
      },
      textarea: {
        empty: 'Fyll i',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Ställ in',
        valid: () => 'Klart',
      },
      file: {
        empty: 'Välj',
        valid: () => 'Ändra',
      },
      list: {
        empty: 'Lägg till',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Sök',
        valid: () => 'Klart',
      },
    },

    cookieConsentModal: {
      title: 'Vår webbplats använder cookies',
      body: 'Genom att acceptera alla cookies godkänner du lagring av cookies på din enhet för att förbättra webbplatsnavigering, analysera webbplatsanvändning och hjälpa till med våra marknadsföringsinsatser.',
      learnMoreLinkText: 'Läs mer om hur vi använder cookies',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Hantera cookies',
      acceptAll: 'Acceptera alla cookies',
      manageTitle: 'Hantera samtyckesinställningar',
      necessaryCookiesTitle: 'Nödvändiga cookies',
      necessaryCookiesBody:
        'Dessa cookies är nödvändiga för att webbplatsen ska fungera och kan inte stängas av i våra system.',
      performanceCookiesTitle: 'Prestanda-cookies',
      performanceCookiesBody:
        'Dessa cookies tillåter oss att räkna besök och trafikkällor så att vi kan mäta och förbättra prestandan på vår webbplats.',
      confirmChoices: 'Bekräfta mina val',
      marketingCookiesTitle: 'Marknadsföringscookies',
      marketingCookiesBody:
        'Dessa cookies tillåter oss att individuellt anpassa reklam och mäta annonsprestanda.',
      functionalCookiesTitle: 'Funktionskakor',
      functionalCookiesBody:
        'Dessa kakor används för att förbättra webbplatsens funktion. Utan dessa kakor kan vissa funktioner bli otillgängliga. Exempel på funktionskakor är webbchattjänster och användarinställningar.',
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Kandidatnamn',
      remove: 'Ta bort',
      importCsv: 'Import CSV',
      invalidEmails: 'Ogiltiga e-postadresser har hittats.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv-poster tillåtna.`,
      importCsvTooltip:
        'CSV-raderna kan innehålla antingen en e-postadress eller både en e-postadress och ett telefonnummer. Varje rad motsvarar en mottagare. Telefonnumren måste vara i internationellt format (E.164), t.ex. <strong>+358</strong>50xxxxxxx.',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'E-postet studsades tillbaka. Kontrollera att mottagaren har fått ditt meddelande.',
      },
      Permanent: {
        General: 'Skickandet av e-postet misslyckades. Mottagarens e-postleverantör avvisade meddelandet.',
        NoEmail: 'E-postadress existerar inte.',
        Suppressed: 'E-postet skickades inte på grund av tidigare misslyckade försök.',
      },
      Transient: {
        General: 'E-postet studsades tillbaka. Kontrollera att mottagaren har fått ditt meddelande.',
        MailboxFull: 'Mottagarens inkorg är full.',
        MessageTooLarge: 'Innehållet av meddelandet är för stort.',
        ContentRejected: 'Innehållet av meddelandet avvisades.',
        AttachmentRejected: 'Bifogade bilagan avvisades.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'Angivet nummer är redan kopplat till en kandidat i intervjun.',
    },

    error403: {
      heading: 'Åtkomst förbjuden',
      content: 'Kontrollera att du är inloggad på rätt konto och har blivit inbjuden att granska denna befattning i Recright. Se även till att Recright inte är öppet i flera webbläsarfönster samtidigt.',
      link: 'Framsidan',
    },

    error404: {
      heading: 'Ingenting där',
      content: 'Vi letade och letade, men det finns ingen webbsida på den adressen som du begärde. Kanske du följde en utgången länk eller i misstag skrev fel adress.',
      link: 'Framsidan',
    },

    error410: {
      heading: 'Stängd',
      content: 'Arbetsplatsen kan ej visas, på grund av att ansökningstiden gått ut eller blivit raderad.',
      link: 'Framsidan',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    footer: {
      terms: 'Recrights användarvillkor',
      license: 'Recrights Allmänna tjänstevillkor',
      privacyPolicy: 'Integritetspolicy',
      customSupport: link => `Kontakta ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Vilket betyg vill du ge intervjuupplevelsen?',
      howWouldYouRateJobAd: 'Hur skulle du betygsätta din ansökningsupplevelse?',
      yourResponseIsAnonymous: 'Ditt svar är anonymt.',
      thankYouFeedback: 'Tack för din feedback!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/sv/recright-anvandaravtal-arbetssokande',
      privacyPolicyLink: 'https://get.recright.com/sv/integritetspolicy/',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Tyvärr är filtypen inte tillåten.',
      isRequired: 'Detta fält är obligatoriskt.',
      isEmail: value => `${value} är inte en giltig e-postadress.`,
      isDate: value => `${value} är inte ett giltigt datum.`,
      invalidUrl: 'Ogiltig URL.',
      singleHireEndError: 'Enkelrekryteringen kan inte användas i längre än 60 dagar',
      isNotTooOldForLive: 'Datumet är i det förflutna.',
      isNotAfterEndDate: 'Valt datum kan inte vara efter platsannonsens slutdatum.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Telefonnumret har redan lagts till.',
      duplicateCompetency: 'Kompetens med detta namn existerar redan',
      isNotDuplicateTemplateName:
        'Det finns redan en e-postmall med det namnet.',
    },

    jobAdApplication: {
      name: 'Namn',
      email: 'E-postadress',
      phone: 'Telefonnummer',
      city: 'Stad',
      applyForPosition: 'Ansök om anställning',
      back: 'Tillbaka',
      continue: 'Fortsätt',
      submit: 'Sänd',
      saveForLater: 'Fortsätt senare',
      namePlaceholder: 'Ange ditt namn',
      emailPlaceholder: 'Ange din e-postadress',
      phonePlaceholder: 'Ange ditt telefonnummer',
      cityPlaceholder: 'Fyll i din nuvarande hemstad',
      links: 'Du kan ange länkar',
      legendLinks: 'Länkar',
      legendAttachments: 'Bilagor',
      legendAdditionalFields: 'Tilläggsinformation',
      legendBasicInfo: 'Grundläggande information',
      coverLetter: 'Följebrev',
      attachments: 'Bilagor',
      introduction: 'Skriv din presentation här',
      thankYou: 'Tack.',
      luck: 'Lycka till!',
      close: 'Stäng',
      required: '* Fälten markerade med en asterisk är obligatoriska.',
    },

    jobAdContainer: {
      endTime: date => (date ? `öppen fram tills ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Sök jobbet',
    },

    jobAdQuickInterview: {
      back: 'Tillbaka',
      submit: 'Sänd',
      saveForLater: 'Fortsätt senare',
      title: 'Snabb videointervju',
      description: 'För att lära känna dig bättre så önskar vi att du kort svarar på vår snabba intervjufråga. Visa din personlighet och ge din ansökan en själ.',
      requiredNote: 'Observera att detta är den del av ansökningsprocessen, och rekryteraren får din ansökan endast efter att du har spelat in ditt svar.',
      reminderNote: 'Du kan spela in svaret genasteller så kan du fortsätta senare genom att motta en påminnelse i din e-post.',
    },

    jobAdRow: {
      responses: 'Ansökningar',
      status: {
        open: 'Öppen',
        filled: 'Ifylld',
        cancelled: 'Annullerad',
        done: 'Klar',
        close: 'Stäng',
        draft: 'Stängd (utkast)',
        hidden: 'Dold',
      },
    },

    interviewRow: {
      responses: 'Kandidater',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Visa LinkedIn profil',
    },

    linkedInButton: {
      error: 'Det gick inte att hämta profilen. Vänligen försök igen.',
      buttonText: 'Ansök med LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Du kan använda din LinkedIn-profil för att förhandsfylla ansökningsblanketten',
      linkedInOr: 'Eller',
      error: 'Det gick inte att hämta profilen. Vänligen försök igen.',
    },

    linkListInput: {
      addField: 'Lägg till',
      removeField: 'Ta bort',
      invalidUrl: 'Ogiltig URL.',
    },

    liveRoom: {
      greeting: name => `Hej, ${name}.`,
      notYetStarted: startTime =>
        `Intervjun har ännu inte börjat. Intervjun börjar klockan ${startTime}.`,
      interviewTitle: title => `Intervjurubrik: ${title}`,
      interviewStartsIn: timeLeft => `Intervjun börjar om: ${timeLeft}`,
      interviewHasEnded: 'Intervjun är avslutad.',
      youHaveLeft: 'Du har lämnat intervjun.',
      rejoinInterview: 'Gå med i intervjun igen',
      joinInterview: 'Gå med i intervjun',
      goToEvaluations: 'Fortsätt till utvärdering',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minuter`,
        guideNotesPlaceHolder: stepTitle => `Anteckningar för ${stepTitle}`,
        goToNextStepButtonText: 'Gå till nästa del',
        totalTime: 'Total tid i intervjun:',
        timeIn: partName => `Tid i ${partName}:`,
        nextStep: stepTitle => `Nästa: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Laddar...',
      saving: 'Sparas...',
      sending: 'Avsändning...',
    },

    modalApplicationForm: {
      applyForPosition: 'Ansök om anställning',
      continue: 'Fortsätt',
      name: 'Ange ditt namn',
      email: 'Ange din e-postadress',
      phoneNumber: 'Ange ditt telefonnummer',
      links: 'Du kan ange länkar',
      legendLinks: 'Länkar',
      legendAttachments: 'Bilagor',
      coverLetter: 'Följebrev',
      attachments: 'Bilagor',
      introduction: 'Skriv din presentation här',
      thankYou: 'Tack.',
      luck: 'Lycka till!',
      close: 'Stäng',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Delbar offentlig länk',
      info: 'Här är en jobbannons offentliga adress som du kan dela.\nAlla som är intresserade av anställningen kan se jobbannonsen \n och sedan besluta om att lämna in ansökan.\nDu får det vanliga meddelandet när ansökningar börjar komma in.\n\nHär är en offentlig länk till jobbannonsen:',
    },

    modalVideoAdd: {
      chooseTitle: 'Lägg till ett nytt videoklipp',
      title: 'Spela in en ny video',
      titlePlaceholder: 'Ange video rubrik här',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Ladda in en ny video',
      info: 'Max storlek för videofiler är 500mb. Vi rekommenderar att du komprimerar videorna innan du laddar upp dem. Så tar uppladdning och konvertering mindre tid.',
    },

    modalCandidateInfo: [
      {
        headline: 'Spela in ditt svar ',
        content: 'så många gånger tills du känner att du är nöjd. Svaren sparas genast efter inspelningen och du kan återkomma till intervjun när som helst via länken som skickats till din epost.',
        mobileContent: 'så många gånger tills du känner att du är nöjd. Lägg till videon i intervjun. Du kommer att se videon laddas upp och sparas i intervjun. Du kan återvända till din ansökan senare via ursprungliga länken som skickats till din email.  <br><br><strong> Om inspelningsrutan är svart och du använder en iPhone/iPad, hittar du instruktionerna <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">härifrån</a></strong>.',
      },
      {
        headline: 'Kontrollera genast efter inspelningen ',
        content: 'att din röst hörs utan problem och att videon spelas normalt. När du trycker på "skicka svar" -knappen, kommer videon att låsas. Det går därmed inte att ändra på ditt svar efter det.',
      },
      {
        headline: 'När du har bandat in alla svar och intervjun är klar, ',
        content: 'tryck "Skicka svaren och slutför intervjun". Du kan inte återkomma till intervjun efter att du tryckt på denna knapp. Om du däremot bestämmer att fortsätta senare skall du trycka på "Fortsätt senare".',
      },
      {
        headline: 'Om du behöver hjälp ',
        content: mailto => `med att svara på frågorna kan du kontakta oss via "Hjälp" -knappen nere till höger på sidan. Du kan även kontakta oss via epost till adressen  ${mailto}.`,
        customContent: link => `Kontakta ${link}`,
      },
    ],

    navigationBar: {
      back: 'Tillbaka',
      dashboard: 'Huvudvy',
      frontpage: 'Framsidan',
    },

    personDetails: {
      stage: 'Fas',
      namePlaceholder: 'Sökande',
      contact: 'Kontakt',
      links: 'Länkar',
      attachments: 'Bilagor',
      coverLetter: 'Följebrev',
      referrer: 'Ursprung',
      referrerInfo: 'Den webbplats från vilken kandidaten kom till tjänsten.',
      noStage: 'Ännu inte flyttad till fasen',
      headerAdditionalInformation: 'Tilläggsinformation',
      lastSeen: time => `Senast sedd ${time}.`,
      state: {
        invited: 'Inbjuden',
        visited: 'Besökte',
        incomplete: 'Ofullständig',
        completed: 'Färdig',
      },
      notVisited: 'Har inte besökt på intervju.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Hittas också i ${count} andra positioner,`,
    },

    phoneInput: {
      placeholder: example => `Telefon i formatet ${example}`,
    },

    questionsAndResponses: {
      response: 'Svar',
      noResponse: 'Inget svar',
      resetQuestionResponse: 'Ta bort kandidatens svar',
      resetQuestionResponseConfirm: questionTitle =>
        `Är du säker på att du vill återställa frågan "${questionTitle}" för kandidaten och ta bort kandidatens svar?`,
      resetQuestionResponseConfirm2:
        'Om du gör detta kan kandidaten svara på frågan på nytt.',
      aiInsights: 'AI insikter',
      showQuestion: 'Visa frågevideon',
      hideQuestion: 'Dölj frågevideon',
      question: 'Fråga',
      nonAnswerableInfo: 'Frågan kan inte besvaras.',
      evaluationCriteriaLabel: 'Bedömningskriterier',
    },

    rating: {
      ownVote: 'Ditt betyg',
      yourVotePlaceholder: 'Du har inte gett din värdering.',
      totalVotes: count => `Totalt ${count} betyg`,
      mobileModalHeader: 'Betygsätt',
      noRatings: 'Inga bedömningar ännu',
      yourRatingReset: 'Ta bort ditt betyg',
      averageRating: 'Genomsnittsbetyg',
      reset: 'nollställ',
    },

    share: {
      share: 'Dela till',
      copy: 'Kopiera länk',
    },

    sort: {
      sort: 'Sortera',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Vald',
      change: 'Ändra',
    },

    video: {
      videoNotFound: 'Video bearbetas eller video hittades inte',
      retry: 'Försök igen',
      originalLanguageLabel: 'Original',
      englishLanguageLabel: 'Engelska',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Lägg till ett nytt videoklipp' : 'Välj fil'),
      videoPlaceholder: 'Spela in ditt svar',
      uploadPlaceholderCandidate: 'Ladda upp ditt svar',
      submit: 'Sänd svaret',
      notAnswered: 'Du har inte ännu svarat',
      remove: 'Ta bort tagningen',
      converting: 'Videon konverteras. Ett ögonblick...',
      uploading: 'Videon laddas upp. Ett ögonblick...',
      error: {
        invalid: 'Vald videofil är för stor. Vänligen välj en annan fil.',
        upload: 'Vi kunde inte ladda upp videon, tyvärr. Vänligen försök på nytt.',
        transcode: 'Den valda videon fungerade inte, vänligen försök på nytt.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Visa mer',
      showLessButtonText: 'Visa mindre',
      infoText1:
        'Håll fliken aktiv i förgrunden under inspelning. Använd inga andra appar under inspelningen.',
      infoText2:
        'Videor med videobakgrund fungerar bäst i de nyaste webbläsarna och på relativt nya och effektiva enheter.',
      infoText3:
        'Se till att inte andra appar använder din mikrofon eller kamera.',
    },

    videoResponse: {
      videoPlaceholder: 'Spela in ditt svar',
      uploadPlaceholder: 'Ladda upp ditt svar',
      submit: 'Sänd svaret',
      notAnswered: 'Du har inte ännu svarat',
      required: 'Denna fråga kräver ett svar',
      startInterview: 'Börja intervjun',
    },

    webcam: {
      useVideoBgButtonText: 'Använd videobakgrund',
      removeVideoBgButtonText: 'Ta bort videobakgrund',
      starting: 'Startar...',
      close: 'Stäng kameran',
      remove: 'Ta bort tagningen',
      record: 'Spela in',
      stop: 'Stoppa',
      retake: 'Gör om',
      submit: 'Sänd svaret',
      processing: 'Bearbetar...',
      converting: 'Videon konverteras. Ett ögonblick...',
      uploading: 'Videon laddas upp. Ett ögonblick...',
      downloading: 'Videon laddas ner. Ett ögonblick...',
      uploadInProgress: 'Videoöverföringen pågår fortfarande, stäng inte webbläsaren och byt inte sida.',
      uploaded: 'Videoklippet har överförts.',
      error: {
        DevicesNotFoundError: 'Unable to use camera or microphone. Please check they are enabled.',
        NotFoundError: 'Unable to use camera or microphone. Please check they are enabled.',
        NotAllowedError: 'You didn\'t give a permission to use the camera or microphone.',
        PermissionDismissedError: 'You dismissed permission dialog. Please give permission to use the camera and microphone.',
        PermissionDeniedError: 'You have denied camera or microphone access.',
        NotReadableError: 'Can\'t read camera or microphone stream. Possible hardware issue.',
        SecurityError: 'Can\'t use camera or microphone because of security error',
        stream: 'Ett fel uppstod. Var god och starta din webbläsare om. Ifall problemet hålls kvar, försök med en annan webbläsare.',
        download: 'Nedladdningen av videoklippet misslyckades. Försök igen?',
        upload: 'Uppladdningen av videoklippet misslyckades. Försök igen?',
        emptyBlob: 'Din webbläsare eller datorminne är full och det går inte att bygga inspelningen. Uppdatera sidan och om det inte hjälper, starta om webbläsaren. Ifall problemet hålls kvar, försök med en annan webbläsare.',
        alternativeRecorder: 'Du kan också ladda upp filer genom att klicka här.',
        reconnecting: 'Anslutningen avbröts. Försöker återansluta',
      },
    },

    flash: {
      starting: 'Initierar...',
      connection_error_hint: 'Nätverksuppkoppling kunde inte upprättas.\nFörsök ladda om sidan.',
      permission_hint: 'Du måste ge tillåtelse åt denna webbsida att använda din webbkamera och din mikrofon.',
      searching_camera_hint: 'Söker en webbkamera...',
      camera_reserved_hint: 'En annan applikation eller webbsida har reserverat din webbkamera.\nVar god, stäng den applikationen och ladda om denna sida.',
      camera_reserved_hint_chrome_extra: '\n\nBästa Chrome-användare, du måste tillåta Recright att använda webbkameran från dialogen under andressfältet.',
      no_camera_hint: 'Webbkameran kunde inte hittas.',
      no_mic_hint: 'Mikrofonen kunde inte hittas.',
      uploading_text: 'Laddar upp ...',
      rtmpt_in_use: 'Detta steg skulle inte behövas om ditt nätverk\nadministratorn tillåter RTMP. Fråga oss hur.',
      preview_text: 'Webbkameran är i förhandsgranskningsläge',
      close_text: 'Stäng kameran',
      remove_text: 'Ta bort tagningen',
      noflash_errortext_install: link => `Det verkar som om du inte har Adobe Flash Player. Du behöver en flash plugin för att spela in videoklipp. Få Flash här: ${link}`,
      noflash_errortext_enable: link => `Om du redan har installerat flash, men du fortfarande ser det här meddelandet. Titta här: ${link}`,
      noflash_errortext_differentbrowser: 'Alternativt kan du prova med en webbläsare som stöder HTML5-inspelning. Vi föreslår Chrome eller Firefox.',
    },

    smsMessages: {
      invitationMessage: title =>
        `Hej! Vi vill inbjuda dig till en videointervju ${title}. Denna inbjudan sändes även till din e-post. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'Detta är en förhandsvisning av intervjun. Videoinspelning är inaktiverad och formulärdata har inte sparats.',
    },
  },
}
